/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Grid } from '@mui/material';
import { flaggedContentViewService } from '../../../../ServiceFactory';
import { ReadOnlyTextFieldView } from '../../../../shared/views/ReadOnlyTextField.view';

interface Props {
	reason?: string;
}

class FlaggedContentDetailsReasonView extends React.Component<Props> {
	render(): JSX.Element {
		const { reason } = this.props;
		return (
			<Grid item xs={12} container>
				<ReadOnlyTextFieldView
					id="reason"
					name="reason"
					label="Meldegrund"
					multiline
					maxRows="5"
					value={flaggedContentViewService().renderInfo(reason)}
					InputProps={{ readOnly: true }}
					InputLabelProps={{
						shrink: true
					}}
					fullWidth
				/>
			</Grid>
		);
	}
}

export default FlaggedContentDetailsReasonView;
